/*
  Google reviews carousel.

  Two jobs:
  1. Colour in each review's stars once FeedSpring has written the rating
     number into the hidden span inside the card.
  2. Move the row left and right when the arrows are clicked.

  FeedSpring fills the markup in after the page loads, so this watches for
  those changes rather than running once and stopping.
*/
(function () {
  var STAR_ON = 'jmc-review__star--on';

  function paintStars(card) {
    var ratingEl = card.querySelector('[feed-field="rating"]');
    if (!ratingEl) return;

    var rating = parseFloat((ratingEl.textContent || '').trim());
    if (isNaN(rating) || rating <= 0) return;

    card.querySelectorAll('[data-star]').forEach(function (star) {
      var position = parseInt(star.getAttribute('data-star'), 10);
      star.classList.toggle(STAR_ON, position <= Math.round(rating));
    });
  }

  function paintAll(root) {
    root.querySelectorAll('[feedspring="post"]').forEach(paintStars);
  }

  function setupRail(section) {
    var rail = section.querySelector('[data-jmc-reviews-rail]');
    if (!rail) return;

    var prev = section.querySelector('[data-jmc-reviews-prev]');
    var next = section.querySelector('[data-jmc-reviews-next]');

    function step(direction) {
      /*
        Move a full visible width at a time. Cards are sized as a fraction of
        the rail — a quarter on desktop, a half on tablet, full on mobile — so
        this advances exactly four, two or one, matching what you can see.
      */
      rail.scrollBy({ left: rail.clientWidth * direction, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    function syncArrows() {
      var atStart = rail.scrollLeft <= 1;
      var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    rail.addEventListener('scroll', syncArrows, { passive: true });
    syncArrows();

    /*
      FeedSpring injects the reviews and the headline figures after load, so
      watch the whole section rather than just the rail.
    */
    new MutationObserver(function () {
      paintAll(section);
      syncArrows();
      syncLiveFigures(section);
    }).observe(section, { childList: true, subtree: true, characterData: true });
  }

  /*
    Copies the live average rating and review count out of the FeedSpring
    fields and into any element elsewhere on the page that asks for them —
    the hero's star line and the stat strip. Those elements ship with a
    sensible fallback in the theme editor, which stays put if FeedSpring is
    slow, blocked or has not been set up.
  */
  function syncLiveFigures(section) {
    var sources = {
      average: section.querySelector('[feed-field="average-rating"]'),
      total: section.querySelector('[feed-field="total"]')
    };

    Object.keys(sources).forEach(function (field) {
      var source = sources[field];
      if (!source) return;

      var value = (source.textContent || '').trim();
      if (!value) return;

      document.querySelectorAll('[data-jmc-review-field="' + field + '"]').forEach(function (el) {
        // Never write back into the source, and never write an unchanged
        // value — that would retrigger the observer watching this section.
        if (el === source || el.textContent.trim() === value) return;
        el.textContent = value;
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.jmc-reviews').forEach(function (section) {
      if (section.dataset.jmcReviewsReady) return;
      section.dataset.jmcReviewsReady = 'true';
      setupRail(section);
      paintAll(section);
      syncLiveFigures(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  init();

  // The theme editor re-renders a section when you edit it; set it up again.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
